import React, { useCallback, useState } from 'react';
import { MenuItem } from '@mui/material';
import { SHOW_LESS, SHOW_MORE } from 'common/constants/pageFilters';
import { MAX_FIRM_ITEMS } from 'common/constants/user';
import FirmItem from '../FirmItem';
import { FirmItemsProps } from './FirmItems.props';
import { firmItemsClasses, FirmItemsRoot } from './FirmItems.styles';

const FirmItems = ({
  firmItems,
  itemType,
  disabled,
  userPermissions,
  shouldCheckAll,
  setUserPermissionsToSave,
}: FirmItemsProps) => {
  const [itemList, setItemList] = useState(
    firmItems.length <= MAX_FIRM_ITEMS ? firmItems : firmItems.slice(0, MAX_FIRM_ITEMS)
  );

  const showLess = useCallback(() => {
    setItemList(firmItems.slice(0, MAX_FIRM_ITEMS));
    const scrollbarContainer = document.getElementById('scrollbar-firm-items');
    const itemsContainer = document.getElementById(`${itemType.toLowerCase()}-subtitle`);
    if (scrollbarContainer && itemsContainer) {
      scrollbarContainer.scrollTop = itemsContainer.offsetTop;
    }
  }, [firmItems, itemType]);

  const showMore = useCallback(() => {
    setItemList(firmItems);
    const scrollbarContainer = document.getElementById('scrollbar-firm-items');
    const itemsContainer = document.getElementById(`${itemType.toLowerCase()}-subtitle`);
    if (scrollbarContainer && itemsContainer) {
      scrollbarContainer.scrollTop = itemsContainer.offsetTop + itemsContainer.offsetHeight;
    }
  }, [firmItems, itemType]);

  const handleClick = useCallback(() => {
    if (itemList.length < firmItems.length) {
      showMore();
    } else {
      showLess();
    }
  }, [firmItems, itemList, showLess, showMore]);

  return (
    <FirmItemsRoot>
      {itemList.map(item => (
        <FirmItem
          key={`${itemType}-${item.id}`}
          item={item}
          disabled={disabled}
          userPermissions={userPermissions}
          itemType={itemType}
          shouldCheckAll={shouldCheckAll}
          setUserPermissionsToSave={setUserPermissionsToSave}
        />
      ))}
      {firmItems.length > MAX_FIRM_ITEMS && (
        <MenuItem onClick={handleClick} className={firmItemsClasses.showMoreLess}>
          {itemList.length < firmItems.length ? SHOW_MORE : SHOW_LESS}
        </MenuItem>
      )}
    </FirmItemsRoot>
  );
};

export default FirmItems;
